import { filter, groupBy, map, reduce } from 'lodash'

const computeMenuTitleHighlights = (dietLabelLegends, allergenLabelLegends) => {
  const highlightsFromLabels = [
    ...map(
      reduce(
        filter(dietLabelLegends, 'isSuggestedByAi'),
        (acc, { highlights, isChoice }) => [
          ...acc,
          ...map(highlights, highlight => ({ ...highlight, isChoice })),
        ],
        [],
      ),
      highlight => ({
        ...highlight,
        matchType: `dietLabelLegend_${highlight.matchType || 'exact'}${
          highlight.isChoice ? '_choice' : ''
        }`,
        originField: highlight.originField,
        startIndex: highlight.posIndex?.[0],
      }),
    ),
    ...map(
      reduce(
        filter(allergenLabelLegends, 'isSuggestedByAi'),
        (acc, { highlights, isChoice }) => [
          ...acc,
          ...map(highlights, highlight => ({ ...highlight, isChoice })),
        ],
        [],
      ),
      highlight => ({
        ...highlight,
        matchType: `dietLabelLegend_${highlight.matchType || 'exact'}${
          highlight.isChoice ? '_choice' : ''
        }`,
        originField: highlight.originField,
        startIndex: highlight.posIndex?.[0],
      }),
    ),
  ]

  return groupBy(filter(highlightsFromLabels, 'menuTitleId'), 'menuTitleId')
}

export default computeMenuTitleHighlights
